import React from "react";
import { waterSystemType } from "../../../utilities/constants/WaterSystemConstants";

const SiteContact = ({ siteContact, county, population, systemType }) => {
  return siteContact ? (
    <React.Fragment>
      <h5>Site Information</h5>
      <ul className="list-style-none">
        <li>
          <h6>Address: </h6>
          <span>
            {" "}
            {siteContact.address1} {siteContact.address2}{" "}
          </span>
        </li>
        <li>
          <h6>City, St.: </h6>
          <span className="text-uppercase">
            {" "}
            {siteContact.city.toLowerCase()}, {siteContact.state}
          </span>
        </li>
        <li>
          <h6>Zipcode: </h6>
          <span> {siteContact.zip}</span>
        </li>
        <li>
          <h6>Phone: </h6>
          <span> {siteContact.phone}</span>
        </li>
        <li>
          <h6>County: </h6>
          <span className="text-uppercase"> {county ? county : ""}</span>
        </li>
        <li>
          <h6>System: </h6>
          <span> {systemType ? waterSystemType[systemType] : ""}</span>
        </li>
        <li>
          <h6>Population: </h6>
          <span> {population ? population.population : ""}</span>
        </li>
      </ul>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <h5>Site Information</h5>
      <ul className="list-style-none">
        <li>
          <h6>Address: </h6>
        </li>
        <li>
          <h6>City, St.: </h6>
        </li>
        <li>
          <h6>Zipcode: </h6>
        </li>
        <li>
          <h6>Phone: </h6>
        </li>
        <li>
          <h6>County: </h6>
          <span className="text-uppercase"> {county ? county : ""}</span>
        </li>
        <li>
          <h6>System: </h6>
          <span> {systemType ? waterSystemType[systemType] : ""}</span>
        </li>
        <li>
          <h6>Population: </h6>
          <span> {population ? population.population : ""}</span>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default SiteContact;
